import { LOGIN_ERROR, LOGIN_LOADING, LOGIN_SUCCESS, RESET_LOGIN_ERROR } from '../actions';

const initialState = {
  success: false,
  loading: false,
  error: null,
};

const login = function (state = initialState, action) {
  switch (action.type) {
    case LOGIN_LOADING: {
      return {
        ...initialState,
        loading: true,
      };
    }

    case LOGIN_SUCCESS: {
      return {
        ...initialState,
        success: true,
        loading: false,
      };
    }

    case LOGIN_ERROR: {
      return {
        loading: false,
        success: false,
        error: action.payload,
      };
    }

    case RESET_LOGIN_ERROR: {
      return {
        loading: false,
        success: false,
        error: null,
      };
    }

    default: {
      return state;
    }
  }
};

export default login;
